import {Route, Routes, useNavigate} from "react-router-dom";
import {Box, Grid, useTheme} from "@mui/material";
import TopToolbar from "../components/toolbars/TopToolbar";
import HomePage from "./HomePage";
import EditProjectPage from "./EditProjectPage";
import ChangePasswordPage from "./auth/ChangePasswordPage";
import TagsPage from "./TagsPage";
import ProfilePage from "./auth/ProfilePage";
import UsersPage from "./UsersPage";
import ReportsPage from "./ReportsPage";
import HomeMadeSnackbar from "../components/snackbars/HomeMadeSnackbar";
import {getAsiaUserFromLocalStorage} from "../session/getAsiaUser";
import {useEffect} from "react";

const LoggedContainer = () => {
    const theme = useTheme();
    const navigate = useNavigate();

    const userResponse = getAsiaUserFromLocalStorage()

    useEffect(() => {
        if(!userResponse){
            navigate('/login')
        }
    }, [userResponse]);

    return (
        <>
        <Box sx={{height: '100%'}}>
            <TopToolbar/>
            <Box sx={{height: `calc(100% - ${theme.mixins.toolbar.minHeight}px)`, width: '100%'}}>
                <Grid container sx={{height: '100%', width: '100%'}}>
                    <Grid item xs={12}>
                        <Routes>
                            {/** ROUTES */}
                            <Route path="/" element={<HomePage/>}/>
                            <Route path="Home" element={<HomePage/>}/>
                            <Route path={'project/edit/:projectId'} element={<EditProjectPage/>}/>
                            <Route path={'project/edit/:projectId/video/:videoId/report/:reportId'} element={<EditProjectPage/>}/>
                            <Route path='tags' element={<TagsPage/>}/>
                            <Route path='profile' element={<ProfilePage/>}/>
                            <Route path='profile/change-password' element={<ChangePasswordPage/>}/>
                            <Route path='users' element={<UsersPage />}/>
                            <Route path='reports' element={<ReportsPage/>}/>
                        </Routes>
                    </Grid>
                </Grid>
                <HomeMadeSnackbar/>
            </Box>
        </Box>
        </>
    )

}
export default LoggedContainer;